 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"3f1bcf5a15ca71f34d37fcb6eee3cc84075c6632","1":"f5c26f76d3742c2f2e832a0a210218d1c46a96a3","2":"fbc8aab28c27071e8616d6cd2b63555b6975a283","3":"2acfa0f79c92c4e2794815990d2f352afbfadc86","4":"97b7d8e619df2d3d92ca16ac63d6bb54512d1ca8","5":"31dd37c4da0cb42c036690431aba53bda0b7f807","6":"c48c844201ab9000ef75ffc30f4cb3477f2e4126","7":"c7f412e6860d4ad712bee8de7222cb8df745fcf5","8":"3ebbf54154a39ef9f233e1505453b825de156b5e","9":"2e7a07661a35919f254ed9b9dc4006b6a33805f9","10":"framework","13":"component---src-pages-404-js","14":"component---src-pages-b-2-b-js","15":"component---src-pages-b-2-c-js","16":"component---src-pages-blog-aktualne-wymiary-grafik-na-facebooku-js","17":"component---src-pages-blog-aktualne-wymiary-grafik-na-instagramie-linkedinie-pinterescie-i-twitterze-js","18":"component---src-pages-blog-biznes-w-czasach-pandemii-js","19":"component---src-pages-blog-brand-hero-js","20":"component---src-pages-blog-dlaczego-warto-zainwestowac-w-lojalnosc-klientow-js","21":"component---src-pages-blog-e-mail-marketing-czym-jest-i-jakie-niesie-ze-soba-korzysci-js","22":"component---src-pages-blog-influencer-marketing-czym-jest-i-dlaczego-warto-w-niego-inwestowac-js","23":"component---src-pages-blog-jak-zbudowac-osobowosc-marki-poznaj-12-archetypow-js","24":"component---src-pages-blog-jaka-powinna-byc-nowoczesna-strona-internetowa-js","25":"component---src-pages-blog-js","26":"component---src-pages-blog-kampanie-w-dobie-koronawirusa-js","27":"component---src-pages-blog-kilka-slow-o-content-marketingu-js","28":"component---src-pages-blog-prawdziwie-czarny-piatek-js","29":"component---src-pages-blog-przepis-na-sukces-czyli-co-to-jest-strategia-marketingowa-js","30":"component---src-pages-blog-przewodnik-po-agencji-interaktywnej-js","31":"component---src-pages-blog-shoper-doskonaly-sposob-sprzedazy-w-internecie-js","32":"component---src-pages-blog-specjalista-social-media-niewidzialna-reka-profili-spolecznosciowych-js","33":"component---src-pages-blog-sztuczna-inteligencja-i-marketing-js","34":"component---src-pages-blog-wzorcowy-przyklad-rebrandingu-czyli-krotka-historia-klapek-kubota-js","35":"component---src-pages-deweloper-js","36":"component---src-pages-index-js","37":"component---src-pages-kariera-js","38":"component---src-pages-kontakt-js","39":"component---src-pages-moto-js","40":"component---src-pages-o-nas-js","41":"component---src-pages-realizacje-artprogres-js","42":"component---src-pages-realizacje-beefury-js","43":"component---src-pages-realizacje-beksinski-js","44":"component---src-pages-realizacje-bloodlab-js","45":"component---src-pages-realizacje-farma-bialka-js","46":"component---src-pages-realizacje-fizosteo-js","47":"component---src-pages-realizacje-fundacja-js","48":"component---src-pages-realizacje-heating-js","49":"component---src-pages-realizacje-janczaki-js","50":"component---src-pages-realizacje-js","51":"component---src-pages-realizacje-klimalab-js","52":"component---src-pages-realizacje-matthias-js","53":"component---src-pages-realizacje-mercedes-js","54":"component---src-pages-realizacje-nykart-js","55":"component---src-pages-realizacje-ohtime-js","56":"component---src-pages-realizacje-perfumeria-online-js","57":"component---src-pages-realizacje-pizza-box-js","58":"component---src-pages-realizacje-pogorzanski-tygiel-smakow-js","59":"component---src-pages-realizacje-ppwb-js","60":"component---src-pages-realizacje-rowerowa-przygoda-js","61":"component---src-pages-realizacje-social-monster-js","62":"component---src-pages-realizacje-social-monster-new-js","63":"component---src-pages-realizacje-streetwear-js","64":"component---src-pages-rozwiazania-js","65":"component---src-pages-uslugi-aplikacje-js","66":"component---src-pages-uslugi-branding-js","67":"component---src-pages-uslugi-copywriting-js","68":"component---src-pages-uslugi-grafika-3-d-js","69":"component---src-pages-uslugi-ilustracje-js","70":"component---src-pages-uslugi-js","71":"component---src-pages-uslugi-kampanie-ads-js","72":"component---src-pages-uslugi-media-js","73":"component---src-pages-uslugi-pozycjonowanie-seo-js","74":"component---src-pages-uslugi-sklepy-internetowe-js","75":"component---src-pages-uslugi-social-media-js","76":"component---src-pages-uslugi-strony-www-js","77":"component---src-pages-uslugi-web-design-js","78":"component---src-sections-career-job-layout-job-layout-js"}[chunkId]||chunkId) + "-" + {"0":"280ce999a2cf233c4369","1":"3d294e8a9b8c02c2332c","2":"885deff26b13942099b7","3":"7396701130452f0f63e8","4":"1c90c3ab2bbd1a54998b","5":"c7b6e8f171fa648d5525","6":"3798c6bc261ca85d9a2f","7":"f1230f2340f4fb269df8","8":"9f83e7d092b2cfe8f383","9":"365207da87ef88b70462","10":"74fc17bfb6a45336c312","13":"dd6907c9abc1210cc0b8","14":"11edd98af07f35112b8e","15":"f081752fcdb551f5b91c","16":"3de9a6fb88d6b21e33cb","17":"e385a212096ea52188af","18":"9910f57fb3f604647ccf","19":"c07b8bad4349cf035806","20":"c0589ab8db8b15859823","21":"ad625bb09c0544437335","22":"83fde63ff88571d75303","23":"a3543853e586bf057202","24":"99acc375074e433298ae","25":"6ad8245c74c20ce48935","26":"110570f6d88a1e84401d","27":"a88346c33b05e9b8dab3","28":"bcced40e2f024f15c0ab","29":"ba1b73c0530d297a6838","30":"a5b663f2382f93627363","31":"d99549163afbb8f478be","32":"ac4720a5c80fb1d5239a","33":"1eecfeafbbee6559b4a7","34":"996ecd8f9dc3a7be640b","35":"e2baace72aa685fc7f94","36":"cfdb9361d463eb9ad544","37":"e450b8393a4242e5199c","38":"3afc3cdd515e9052b0a5","39":"a0126f50b3e71e753b01","40":"682be871d726cd8dc1fa","41":"600f7d02411410e5cf8e","42":"0576cf7455a2b6ca8ff4","43":"fca59d283678a72c2934","44":"0ba2e6bed0a3fb92e302","45":"494c190244a4adfc2787","46":"21adebc287b96e8e783a","47":"ce2c4042578cc604b656","48":"89d6554634a0276ce0b1","49":"b1fc1cabc1f276b5b639","50":"bf8bf1bffadda090bd1d","51":"0039960145c302ca1847","52":"d99cf493c274d0bca9ac","53":"1e44f3968c0071938813","54":"f2649f3bd1192b4cea5c","55":"e372e48fa93937466ba1","56":"5c30f6369c1eb99e8641","57":"852b1f9c27dc83c5327d","58":"af9292fb5f0c49d7873c","59":"2e76376262f209b35d87","60":"8574f94467588a0e06db","61":"8ec0f89089e11d355a9a","62":"96522aa5106da895dbc4","63":"e3eff46019a2e9cdadca","64":"97f2e3d1c69cfe11ce8e","65":"e2ab36ea01b3d0ff892b","66":"39ec877176cc1a118726","67":"7c3b2199653cec56503d","68":"f941adf9d750234db51c","69":"9eeaf4437e67fa9bb219","70":"ac09275c916d39da5cf2","71":"3ee91b21726cb1c167aa","72":"e62c933f698e3744d29e","73":"f6f819a2fefa94d62877","74":"35edcf53da9e35907f52","75":"f70d91588e0050ca7175","76":"072bf6c3edd1c525caf5","77":"4d5dddd48f8c294b019e","78":"e1a47053eba9dd3b241d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
